import {IRouteParams, TRouteId} from "../../index";
import {global} from "../../appContext";
import {findShellParentForTabId, navigateToShellTab} from "../../util/pageShellTabRoutes";

export namespace nsTabList {
    /** Navigate to tab child hash when the tab is registered under a PageShell. */
    export function navigateToTabRoute(routeId: TRouteId, routeParams?: IRouteParams) {
        const params = routeParams ?? global.router.currentRoute()?.__routeParams ?? {};
        const shellParent = findShellParentForTabId(routeId);
        if (shellParent) {
            navigateToShellTab(shellParent, routeId, params);
        }
    }
}
